import { render, staticRenderFns } from "./search-products.vue?vue&type=template&id=61f20538&scoped=true&"
import script from "./search-products.vue?vue&type=script&lang=js&"
export * from "./search-products.vue?vue&type=script&lang=js&"
import style0 from "./search-products.vue?vue&type=style&index=0&id=61f20538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f20538",
  null
  
)

export default component.exports